import { isNotNullUndefinedOrEmptyString } from "@/features/shared/tools"

export const UPLOAD_FICHIER_INJECT = Symbol('upload-fichier')

export const MAX_FILE_LENGTH = Object.freeze(parseInt(import.meta.env.VITE_UPLOAD_MAX_SIZE ?? '5'))
export const MAX_FILE_COUNT = Object.freeze(parseInt(import.meta.env.VITE_UPLOAD_MAX_COUNT ?? '5'))
const ACCEPTED_FILE_TYPES_DEFAULT = 'pdf,jpg,png,xls,xlsx,doc,docx,csv'
export const ACCEPTED_FILE_TYPES =
    Object.freeze<string[]>(
        (import.meta.env.VITE_UPLOAD_ACCEPT_FILE ?? ACCEPTED_FILE_TYPES_DEFAULT).split(',')
            ?.filter(isNotNullUndefinedOrEmptyString)
            ?.map((item: string) => `.${item}`)
    )
